import { useEffect, useState } from 'react';
import { request } from '../api/http';
import { ROUTES } from '../api/routes';
import { Alert, Card } from '../components/ui';
import { API_URL } from '../config/env';

type Probe =
  { state: 'loading' } | { state: 'up'; body: string } | { state: 'down'; error: string };

/** Comprobación de extremo a extremo: confirma que el panel alcanza la puerta. */
export function BackendStatusPage() {
  const [probe, setProbe] = useState<Probe>({ state: 'loading' });

  useEffect(() => {
    let cancelled = false;
    request<unknown>({ method: 'GET', path: ROUTES.health, auth: false })
      .then((body) => {
        if (!cancelled) setProbe({ state: 'up', body: JSON.stringify(body) });
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        setProbe({
          state: 'down',
          error: error instanceof Error ? error.message : String(error),
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="grid gap-4">
      <div>
        <h1 className="text-xl font-semibold tracking-tight">Estado del backend</h1>
        <p className="text-sm opacity-60">{`${API_URL}${ROUTES.health}`}</p>
      </div>

      <Card title="Sonda">
        {probe.state === 'loading' && <p className="text-sm opacity-60">Consultando…</p>}
        {probe.state === 'up' && <pre className="text-sm">{probe.body}</pre>}
        {probe.state === 'down' && (
          <Alert>
            Sin respuesta ({probe.error}). Arranca el backend con{' '}
            <code>pnpm --filter @occ/backend dev</code>.
          </Alert>
        )}
      </Card>
    </section>
  );
}
